import { useLoaderData, useParams } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { myOrdersMsg, omaElisaForEmployeeMsg, t } from '../../../../../common/i18n/index.js';
import { SubscriptionActionDetailsView } from '../../../../../components/SubscriptionActionDetails/SubscriptionActionDetailsView.js';
import type { RequestId } from '../../../../../common/constants/pathInterfaces.js';
import type { SubscriptionActionsResponse } from '../../../../../generated/api/subscriptionActionsResponse';

export const EoeOwnChangeRequestPath = () => {
  const { requestId } = useParams<RequestId>();
  const { subscriptionActions } = useLoaderData() as SubscriptionActionsResponse;

  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.EG6F(myOrdersMsg)]);

  return (
    <SubscriptionActionDetailsView
      breadCrumbPaths={[
        { name: t.H6JV(omaElisaForEmployeeMsg), path: paths.EMPLOYEE_HOME },
        { name: t.EG6F(myOrdersMsg), path: paths.EMPLOYEE_OWN_CHANGE_REQUESTS },
        { name: `${requestId}` },
      ]}
      subscriptionAction={subscriptionActions[0]}
      isEmployee={true}
      isEoe={true}
    />
  );
};
